import { CountUp } from 'countup.js';
import { wrapString } from '../utils/wrappers';
import { onDomReady } from '../utils/dom';
/** @import { CountUpOptions } from 'countup.js' */

const numberRegex = /(?:\d{1,3}[.,]?)+\d*/;

/**
 * @description
 * Set class or id with "counter" keyword in it on mod_article.
 * Script is going to automatically find and pack up the numbers inside span.number element.
 *
 * @param {string} countersSelector - you can override the default selector, which is - '[class*="counter"], [id*="counter"]'
 * @param {string} numbersSelector - selector into element with number, default - 'p:first-child'
 * @param {CountUpOptions} countUpOptions - options for CountUp script - https://github.com/inorganik/countUp.js
 *
 * @example
 * <div.mod_article.counters>
 *      [...]
 *          <div.text_container>
 *              <p>2000 KwH</p>
 *          </div.text_container>
 *      [...]
 * </div.mod_article.counters>
 */
function countUp(
    resetOnlyFromTop = true,
    countUpOptions = {},
    countersSelector = '[class*="counter"], [id*="counter"]',
    numbersSelector = 'p:first-child',
) {
    const options = Object.assign({ separator: '.', autoAnimate: resetOnlyFromTop ? false : true }, countUpOptions);

    let sectionsWithCounters = document.querySelectorAll(countersSelector);

    sectionsWithCounters.forEach(function (section) {
        let pWithNumbers = section.querySelectorAll(numbersSelector);

        let elementsWithNumbers = [...pWithNumbers].filter((el) => numberRegex.test(el.innerText));

        elementsWithNumbers.forEach((elementWithNumber) => {
            createCounter(elementWithNumber, options);
        });
    });
}

/**
 * @param {HTMLElement} elementWithNumber
 * @param {CountUpOptions} options
 */
function createCounter(elementWithNumber, options) {
    let finalNumber = elementWithNumber.innerHTML.match(numberRegex)[0];

    elementWithNumber.innerHTML = elementWithNumber.innerHTML.replace(
        finalNumber,
        wrapString(finalNumber, 'span', {
            class: 'countUp_number',
        }),
    );

    finalNumber = finalNumber.replaceAll(/[.,]/g, '');

    let numberSpan = elementWithNumber.querySelector('span.countUp_number');

    let counter = new CountUp(numberSpan, finalNumber, options);

    if (!options.autoAnimate) appendOwnListeners(counter);
}

// Functions to make counters to be fired only if scrolled from top

function appendOwnListeners(counter) {
    counter.paused = false;

    window.addEventListener('scroll', setScrollListenerEvent);

    window.addEventListener('resize', function () {
        // positions = calculateNewPositions(counter.el);
        window.removeEventListener('scroll', setScrollListenerEvent);
        window.addEventListener('scroll', setScrollListenerEvent);
    });

    function setScrollListenerEvent() {
        countUpOnScroll(counter);
    }

    // Zähler, die beim Laden schon im Viewport stehen (z. B. direkt unter dem Titelbild), bekommen
    // ohne Scroll-Ereignis nie einen Start. Erste Prüfung erst nach dem Loader-Fade (base.js setzt
    // html.loaded 400 ms nach window.load), sonst zählt es unsichtbar unter dem Loader hoch.
    const LOADER_FADE_MS = 450;

    if (document.readyState === 'complete') {
        setTimeout(setScrollListenerEvent, LOADER_FADE_MS);
    } else {
        window.addEventListener('load', () => setTimeout(setScrollListenerEvent, LOADER_FADE_MS), { once: true });
    }

    /**
     * @param {CountUp} counter
     */
    function countUpOnScroll(counter) {
        const bottomOfScroll = window.innerHeight + window.scrollY;
        const rect = counter.el.getBoundingClientRect();

        const topOfEl = rect.top + window.scrollY;
        const bottomOfEl = rect.top + rect.height + window.scrollY;

        if (bottomOfEl < bottomOfScroll && bottomOfEl > window.scrollY && !counter.paused) {
            // in view
            counter.start();
            counter.paused = true;
        } else if (topOfEl > bottomOfScroll && counter.paused) {
            counter.reset();
            counter.paused = false;
        }
    }
}

onDomReady(() => {
    countUp();
});
